module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ja_hokkaido-d0394d65c8c9068a9fec94b2dca0d235.jpg";